import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-popupimmudbcontent',
  templateUrl: './popupimmudbcontent.component.html',
  styleUrls: ['./popupimmudbcontent.component.scss']
})
export class PopupimmudbcontentComponent implements OnInit {
  doc_id: any;
  selectedIndexVal: any
  htmlContent: string | null = null;
  blobUrl: string | null = null;
  safeurl: any;
  alldata: any;
  showLoader: boolean = false

  constructor(public dialogRef: MatDialogRef<PopupimmudbcontentComponent>, @Inject(MAT_DIALOG_DATA) public logParams: any, private commonServ: CommonService,
    private http: HttpClient, private sanitizer: DomSanitizer, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.doc_id = this.logParams['doc_id']
    this.alldata = this.logParams['alldata']
    console.log(" this.alldata", this.alldata)
    console.log("doc_id", this.doc_id)
    this.commonServ.downloadpdffile(this.doc_id).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log("test response", response[0].doc_contenet)
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = this.alldata['doc_name'];
      var url = this.commonServ.fetchAndDisplayBlob(response[0].doc_contenet, filename);
      console.log("url", url)
      this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
        this.blobUrl = URL.createObjectURL(blob);
        this.safeurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl)
        // this.modalService.open(this.popupview, { size: 'lg' });
      });
    })
  }

  downloadpdffile() {


    this.commonServ.downloadpdffile(this.doc_id).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log("Test reponse", response[0].doc_contenet)
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = this.alldata['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
    })
  }

  downloadpdffile2() {
    this.showLoader = true

    this.commonServ.downloadpdffile2(this.doc_id).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = this.alldata['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
      this.showLoader = false
    })
  }

}
